import React from 'react'
import { Box, useMediaQuery } from '@mui/material'

const Content = ({children, width = "70%"}) => {
	const matches = useMediaQuery("(min-width:600px)");
	return <Box p={1} sx={{ width: matches ? width : "90%", margin: "auto", maxWidth:"1200px" }}>{children}</Box>;
}

export default Content
